import * as Yup from "yup";
export const formInitialValues = {
  Plant_Location_Name: "",
  Plant_Plot_Name: "",
  BarCode_Auto_ID: 0,
  Plantation_Monitoring_Type: "",
  PlantGrowth_Height: "",
  PlantGrowth_Collar_Diameter: "",
  Canopy_cover: "",
  Moisture_content: "",
  Survivability: "",
  PlantGrowth_Flower_Count: "",
  PlantGrowth_Fruit_Count: "",
  Leaf_bud_formation: "",
  Leaf_fall: "",
  Flower_Bud_Formation: "",
  Open_Flower: "",
  Fruit_Seed_Formation: "",
  Fruit_Seed_Ripe: "",
  Fruit_Seed_Fall: "",
  Monitoring_Remark: "",
  Latitude: "",
  Longitude: "",
  Altitude_meter: 0,
  Plant_Scientific_Name: "",
  Plant_Img: [],
  conditionalValidation: "",
  // new changes - tag v3.0.1
  Nitrogen: "",
  Phosphate: "",
  Potassium: "",
  Soil_PH: "",
  Soil_Temperature: "",
  Soil_Moisture: "",
  Electrical_Conductivity: "",
  // Plant_Status: "",
};
const decimalRegex = /^\d+(\.\d{0,2})?$/; // Regex to match up to 2 decimal places

export const validationSchema = Yup.object().shape({
  Plant_Plot_Name: Yup.string().required("Plant Plot Name is required"),
  // Plant_Status: Yup.string().required("Plant Status is required"),
  Plant_Scientific_Name: Yup.string().required(
    "Plant Plantation Name is required"
  ),
  Plantation_Monitoring_Type: Yup.string().required(
    "Monitoring Type is required"
  ),

  Plant_Location_Name: Yup.string().required("Plant Location Name is required"),

  PlantGrowth_Flower_Count: Yup.number()
    .nullable()
    .typeError("Plant Growth Flower Count must be a number")
    .when("Plantation_Monitoring_Type", {
      is: (value) => value === "Qualitative Monitoring",
      then: () =>
        Yup.number()
          .moreThan(0, "Plant Growth Flower count must be greater than 0")
          .max(99999, "Plant Growth count must be less than or equal to 99999")
          .nullable(),
    }),

  PlantGrowth_Fruit_Count: Yup.number()
    .nullable()
    .typeError("Plant Growth Fruit Count must be a number")
    .when("Plantation_Monitoring_Type", {
      is: (value) => value === "Qualitative Monitoring",
      then: () =>
        Yup.number()
          .moreThan(0, "Plant Growth Fruit count must be greater than 0")
          .max(
            99999,
            "Plant Growth Fruit must count be less than or equal to 99999"
          )
          .nullable(),
    }),

  Leaf_bud_formation: Yup.string()
    .nullable()
    .when("Plantation_Monitoring_Type", {
      is: (value) => value === "Qualitative Monitoring",
      then: () => Yup.string().nullable(),
    }),

  Leaf_fall: Yup.string()
    .nullable()
    .when("Plantation_Monitoring_Type", {
      is: (value) => value === "Qualitative Monitoring",
      then: () => Yup.string().nullable(),
    }),

  Flower_Bud_Formation: Yup.string()
    .nullable()
    .when("Plantation_Monitoring_Type", {
      is: (value) => value === "Qualitative Monitoring",
      then: () => Yup.string().nullable(),
    }),

  Open_Flower: Yup.string()
    .nullable()
    .when("Plantation_Monitoring_Type", {
      is: (value) => value === "Qualitative Monitoring",
      then: () => Yup.string().nullable(),
    }),

  Fruit_Seed_Formation: Yup.string()
    .nullable()
    .when("Plantation_Monitoring_Type", {
      is: (value) => value === "Qualitative Monitoring",
      then: () => Yup.string().nullable(),
    }),

  Fruit_Seed_Ripe: Yup.string()
    .nullable()
    .when("Plantation_Monitoring_Type", {
      is: (value) => value === "Qualitative Monitoring",
      then: () => Yup.string().nullable(),
    }),

  Fruit_Seed_Fall: Yup.string()
    .nullable()
    .when("Plantation_Monitoring_Type", {
      is: (value) => value === "Qualitative Monitoring",
      then: () => Yup.string().nullable(),
    }),
  conditionalValidation: Yup.string().when("Plantation_Monitoring_Type", {
    is: (value) =>
      ["Qualitative Monitoring", "Quantitative Monitoring"].includes(value),
    then: () =>
      Yup.string()
        .test(
          "any-of-one",
          "Please fill value in at least one field",
          (value, context) => {
            const fieldsToCheck = [
              "PlantGrowth_Flower_Count",
              "PlantGrowth_Fruit_Count",
              "Leaf_bud_formation",
              "Leaf_fall",
              "Flower_Bud_Formation",
              "Open_Flower",
              "Fruit_Seed_Formation",
              "Fruit_Seed_Ripe",
              "Fruit_Seed_Fall",
            ];

            const fieldsQuantitative = [
              // 'PlantGrowth_Height',
              "PlantGrowth_Collar_Diameter",
              "Canopy_cover",
              "Moisture_content",
              "Survivability",
            ];

            let hasNonUndefinedValues = false;
            if (
              context.options.context["Plantation_Monitoring_Type"] ===
              "Qualitative Monitoring"
            ) {
              hasNonUndefinedValues = fieldsToCheck.every(
                (field) => context.options.context[field] === undefined
              );
            }
            let hasNonUndefinedValuesForQuantitative = false;
            if (
              context.options.context["Plantation_Monitoring_Type"] ===
              "Quantitative Monitoring"
            ) {
              hasNonUndefinedValuesForQuantitative = fieldsQuantitative.every(
                (field) => context.options.context[field] === undefined
              );
            }

            // Your validation logic here
            if (hasNonUndefinedValues) {
              // If the condition fails, return an error message
              return context?.createError({
                path: context.path, // Field path
                message:
                  "At least one of the fields is required for Qualitative Monitoring", // Custom error message
              });
            }

            if (hasNonUndefinedValuesForQuantitative) {
              return context?.createError({
                path: context.path, // Field path
                message:
                  "At least one of the fields is required for Quantitative Monitoring", // Custom error message
              });
            }

            return true;
          }
        )
        .nullable(),
  }),

  // Add more fields here if needed
  PlantGrowth_Height: Yup.number()
    .nullable()
    .when("Plantation_Monitoring_Type", {
      is: (value) => value === "Quantitative Monitoring",
      then: () =>
        Yup.number()
          .required("Plant Growth Height is required")
          .nullable()
          .moreThan(0, "Plant Growth Height must be greater than 0")
          // .positive('Plant Growth Height must be a positive number')
          .max(99999, "Plant Growth Height must be less than or equal to 99999")
          .test(
            "is-decimal",
            "Plant Growth height must have up to 2 decimal places",
            (value) => {
              if (value !== undefined && value !== null) {
                return decimalRegex.test(value.toString());
              }
              return true; // Allow undefined values
            }
          ),
      // .min(1, 'Plant Growth Height must be greater than or equal to 1'),
    }),
  PlantGrowth_Collar_Diameter: Yup.number()
    .nullable()
    .when("Plantation_Monitoring_Type", {
      is: (value) => value === "Quantitative Monitoring",
      then: () =>
        Yup.number()
          .nullable()
          // .positive('Plant Growth Collar Diameter must be a number')
          .moreThan(0, "Plant Collar Diameter must be greater than 0")
          .max(
            99999,
            "Plant Collar Diameter must be less than or equal to 99999"
          )
          .test(
            "is-decimal",
            "Plant Collar Diameter must have up to 2 decimal places",
            (value) => {
              if (value !== undefined && value !== null) {
                return decimalRegex.test(value.toString());
              }
              return true; // Allow undefined values
            }
          ),
      // .min(1, 'Plant Growth Collar Diameter must be greater than or equal to 1'),
    }),
  Canopy_cover: Yup.number()
    .nullable()
    .when("Plantation_Monitoring_Type", {
      is: (value) => value === "Quantitative Monitoring",
      then: () =>
        Yup.number()
          .nullable()
          // .positive('Canopy Cover must be a number')
          .moreThan(0, "Canopy Cover must be greater than 0")
          .max(99999, "Canopy Cover must be less than or equal to 99999")
          .test(
            "is-decimal",
            "Canopy Cover must have up to 2 decimal places",
            (value) => {
              if (value !== undefined && value !== null) {
                return decimalRegex.test(value.toString());
              }
              return true; // Allow undefined values
            }
          ),
    }),
  Moisture_content: Yup.number()
    .nullable()
    .when("Plantation_Monitoring_Type", {
      is: (value) => value === "Quantitative Monitoring",
      then: () =>
        Yup.number()
          .required()
          .nullable()
          // .positive('Moisture Content must be a number')
          .moreThan(0, "Moisture Content must be greater than 0")
          .max(99999, "Moisture Content must be less than or equal to 99999")
          .test(
            "is-decimal",
            "Moisture Content must have up to 2 decimal places",
            (value) => {
              if (value !== undefined && value !== null) {
                return decimalRegex.test(value.toString());
              }
              return true; // Allow undefined values
            }
          ),
    }),

  Nitrogen: Yup.number()
    .nullable()
    .typeError("Nitrogen must be a number")
    .when("Plantation_Monitoring_Type", {
      is: (value) => value === "Quantitative Monitoring",
      then: () =>
        Yup.number()
          .required("Nitrogen is required")
          .moreThan(0, "Nitrogen must be greater than 0")
          .max(99999, "Nitrogen must be less than or equal to 99999")
          .nullable()
          .test(
            "is-decimal",
            "Nitrogen must have up to 2 decimal places",
            (value) => {
              if (value !== undefined && value !== null) {
                return decimalRegex.test(value.toString());
              }
              return true; // Allow undefined values
            }
          ),
    }),
  Phosphate: Yup.number()
    .nullable()
    .typeError("Nitrogen must be a number")
    .when("Plantation_Monitoring_Type", {
      is: (value) => value === "Quantitative Monitoring",
      then: () =>
        Yup.number()
          .required("Phosphate is required")
          .moreThan(0, "Phosphate must be greater than 0")
          .max(99999, "Phosphate must be less than or equal to 99999")
          .nullable()
          .test(
            "is-decimal",
            "Phosphate must have up to 2 decimal places",
            (value) => {
              if (value !== undefined && value !== null) {
                return decimalRegex.test(value.toString());
              }
              return true; // Allow undefined values
            }
          ),
    }),
  Potassium: Yup.number()
    .nullable()
    .typeError("Nitrogen must be a number")
    .when("Plantation_Monitoring_Type", {
      is: (value) => value === "Quantitative Monitoring",
      then: () =>
        Yup.number()
          .required("Potassium is required")
          .moreThan(0, "Potassium must be greater than 0")
          .max(99999, "Potassium must be less than or equal to 99999")
          .nullable()
          .test(
            "is-decimal",
            "Potassium must have up to 2 decimal places",
            (value) => {
              if (value !== undefined && value !== null) {
                return decimalRegex.test(value.toString());
              }
              return true; // Allow undefined values
            }
          ),
    }),
  Soil_PH: Yup.number()
    .nullable()
    .typeError("Nitrogen must be a number")
    .when("Plantation_Monitoring_Type", {
      is: (value) => value === "Quantitative Monitoring",
      then: () =>
        Yup.number()
          .required("Soil is required")
          .moreThan(0, "Soil Ph must be greater than 0")
          .max(99999, "Soil Ph must be less than or equal to 99999")
          .nullable()
          .test(
            "is-decimal",
            "Soil Ph must have up to 2 decimal places",
            (value) => {
              if (value !== undefined && value !== null) {
                return decimalRegex.test(value.toString());
              }
              return true; // Allow undefined values
            }
          ),
    }),
  Soil_Temperature: Yup.number()
    .nullable()
    .typeError("Nitrogen must be a number")
    .when("Plantation_Monitoring_Type", {
      is: (value) => value === "Quantitative Monitoring",
      then: () =>
        Yup.number()
          .required("Soil Temperature is required")
          .moreThan(0, "Soil Temperature must be greater than 0")
          .max(99999, "Soil Temperature must be less than or equal to 99999")
          .nullable()
          .test(
            "is-decimal",
            "Soil Temperature must have up to 2 decimal places",
            (value) => {
              if (value !== undefined && value !== null) {
                return decimalRegex.test(value.toString());
              }
              return true; // Allow undefined values
            }
          ),
    }),
  Soil_Moisture: Yup.number()
    .nullable()
    .typeError("Nitrogen must be a number")
    .when("Plantation_Monitoring_Type", {
      is: (value) => value === "Quantitative Monitoring",
      then: () =>
        Yup.number()
          .required("Soil Moisture is required")
          .moreThan(0, "Soil Moisture must be greater than 0")
          .max(99999, "Soil Moisture must be less than or equal to 99999")
          .nullable()
          .test(
            "is-decimal",
            "Soil Moisture must have up to 2 decimal places",
            (value) => {
              if (value !== undefined && value !== null) {
                return decimalRegex.test(value.toString());
              }
              return true; // Allow undefined values
            }
          ),
    }),
  Electrical_Conductivity: Yup.number()
    .nullable()
    .typeError("Electrical Conductivity must be a number")
    .when("Plantation_Monitoring_Type", {
      is: (value) => value === "Quantitative Monitoring",
      then: () =>
        Yup.number()
          .required("Electrical Conductivity is required")
          .moreThan(0, "Electrical Conductivity must be greater than 0")
          .max(
            99999,
            "Electrical Conductivity must be less than or equal to 99999"
          )
          .nullable()
          .test(
            "is-decimal",
            "Electrical Conductivity must have up to 2 decimal places",
            (value) => {
              if (value !== undefined && value !== null) {
                return decimalRegex.test(value.toString());
              }
              return true; // Allow undefined values
            }
          ),
    }),
  Survivability: Yup.string()
    .nullable()
    .when("Plantation_Monitoring_Type", {
      is: (value) => value === "Quantitative Monitoring",
      then: () => Yup.string().nullable(),
    }),

  Monitoring_Remark: Yup.string()
    .max(255, "Monitoring Remark must be at most 255 characters")
    .nullable(), // Allow null or undefined values,
  Plant_Img: Yup.array()
    .nullable()
    .required("Please upload at least 1 image.")  // Ensure at least one image is uploaded
    .min(1, "Please upload at least 1 image.")  // Minimum of one image
    .test("FILE_SIZE", "Please upload files up to 4MB each.", (value) => {
      console.log(value, "value")
      if (value && value.length) {
        return value.every((file) => file.size <= 4000000);
      }
      return true;
    })
    .test(
      "fileFormat",
      "Please upload files in jpg/png/jpeg format only.",
      (value) => {
        if (value && value.length) {
          return value.every((file) =>
            ["image/png", "image/jpeg", "image/jpg"].includes(file.type)
          );
        }
        return true;
      }
    )
    .test(
      "fileCount",
      "Please upload up to 4 files only.",
      (value) => {
        if (value) {
          return value.length <= 4;
        }
        return true;
      }
    ),
});

export function debounce(func, delay) {
  let timeoutId;

  return function (...args) {
    const context = this;

    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      func.apply(context, args);
    }, delay);
  };
}

export function replaceDotWithUnderscore(obj) {
  const result = {};

  for (const key in obj) {
    // eslint-disable-next-line no-prototype-builtins
    if (obj.hasOwnProperty(key)) {
      const newKey = key.replace(/\./g, "_");

      if (typeof obj[key] === "object" && !Array.isArray(obj[key])) {
        // Recursively process nested objects
        result[newKey] = replaceDotWithUnderscore(obj[key]);
      } else {
        // Keep non-object values as-is
        result[newKey] = obj[key];
      }
    }
  }

  return result;
}

export const excludeEmptyFields = [
  "PlantGrowth_Height",
  "PlantGrowth_Collar_Diameter",
  "Canopy_cover",
  "Moisture_content",
  "Survivability",
  "PlantGrowth_Flower_Count",
  "PlantGrowth_Fruit_Count",
  "Leaf_bud_formation",
  "Leaf_fall",
  "Flower_Bud_Formation",
  "Open_Flower",
  "Fruit_Seed_Formation",
  "Fruit_Seed_Ripe",
  "Fruit_Seed_Fall",
  "Monitoring_Remark",
  /* new changes - tag v3.0.1 */
  "Nitrogen",
  "Phosphate",
  "Potassium",
  "Soil_PH",
  "Soil_Temperature",
  "Soil_Moisture",
  "Electrical_Conductivity",
];

/* new changes - tag v3.0.1 */

export const plantStatus = [
  { value: "Growing", label: "Growing" },
  {
    value: "Non-Growing",
    label: "Non-Growing",
  },
];
export const MAX_CHARACTER_LENGTH = 250;
